import { toWSDateString, WSTableCell } from "@wingspanhq/fe-component-library";
import React from "react";
import { queriesPayPeriods } from "@query";

type Props = {
  payPeriodId?: string | null;
};

/**
 * The pay period a work log is connected to.
 *
 * `WorkLog` carries only `payPeriodId`, so the label comes from the account's
 * pay-period collection. Every cell shares one `listPayPeriods` query key, so
 * React Query resolves this in a single request no matter how many rows render
 * — and it is the same query the pay-period filter already loads.
 */
export const PayPeriodCell: React.FC<Props> = props => {
  const queryPayPeriods = queriesPayPeriods.listPayPeriods.useQueryAll(
    undefined,
    { enabled: !!props.payPeriodId, refetchOnMount: false }
  );

  if (!props.payPeriodId) {
    return <WSTableCell text="—" />;
  }

  const payPeriod = (queryPayPeriods.flatData ?? []).find(
    period => period.id === props.payPeriodId
  );

  // Unresolved (still loading, or a period outside the account's collection)
  // reads the same as unassigned — there is nothing truthful to show either way.
  if (!payPeriod?.startDate || !payPeriod?.endDate) {
    return <WSTableCell text="—" />;
  }

  return (
    <WSTableCell
      text={`${toWSDateString(
        payPeriod.startDate,
        "monthDayYear"
      )} - ${toWSDateString(payPeriod.endDate, "monthDayYear")}`}
    />
  );
};
